import { SelectOption, ValidationItems } from '@kanda-libs/ks-component-ts';
import { JobItem } from '@kanda-libs/ks-frontend-services';

export const BASE_ITEM: JobItem = {
  title: '',
  quantity: 100,
  price: {
    amount: 0,
    currency: 'GBP' as JobItem['price']['currency'],
  },
  vat: {
    amount: 0,
    currency: 'GBP' as JobItem['price']['currency'],
  },
  vat_rate: '20%' as JobItem['vat_rate'],
};

export const DESCRIPTION_VALIDATION = {
  minLength: { value: 1, message: 'Description requires minimum length of 1' },
};

const TIMEFRAME_OPTIONS: SelectOption[] = [
  {
    name: "I'm flexible on the start date",
    value: "I'm flexible on the start date",
  },
  {
    name: 'Urgently (within 48 hours)',
    value: 'Urgently (within 48 hours)',
  },
  {
    name: 'Within 2 weeks',
    value: 'Within 2 weeks',
  },
  {
    name: 'Within 1 month',
    value: 'Within 1 month',
  },
  {
    name: "I'm researching or budgeting the work",
    value: "I'm researching or budgeting the work",
  },
];

const CALLBACK_OPTIONS: SelectOption[] = [
  {
    name: 'When convenient for the tradesperson',
    value: 'When convenient for the tradesperson',
  },
  {
    name: 'As soon as possible',
    value: 'As soon as possible',
  },
  {
    name: 'Mornings (before 12PM)',
    value: 'Mornings (before 12PM)',
  },
  {
    name: 'Afternoons (12PM to 6PM)',
    value: 'Afternoons (12PM to 6PM)',
  },
  {
    name: 'Evenings (after 6PM)',
    value: 'Evenings (after 6PM)',
  },
];

export const FIELD_PROPS = {
  timeframe: {
    label: 'When do you need this doing?',
    name: 'consumer_preferences.timeframe',
    options: TIMEFRAME_OPTIONS,
    placeholder: 'Select...',
  },
  callback: {
    label: 'What time is best for a callback?',
    name: 'consumer_preferences.callback',
    options: CALLBACK_OPTIONS,
    placeholder: 'Select...',
  },
};

export const TIMEFRAME_VALIDATION: ValidationItems = {
  required: {
    value: true,
    message: 'Timeframe is required',
  },
};

export const CALLBACK_VALIDATION: ValidationItems = {
  required: {
    value: true,
    message: 'Callback time is required',
  },
};

export const CLASS_NAMES = {
  header: 'text-20-24-em md:text-24-28-em mb-4',
  subheader: 'text-14-22 md:text-16-24 mb-6',
};
